import { render, staticRenderFns } from "./EmergencyOrderStatusChip.vue?vue&type=template&id=5c490a20"
import script from "./EmergencyOrderStatusChip.vue?vue&type=script&lang=js"
export * from "./EmergencyOrderStatusChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports